import { render, staticRenderFns } from "./DossierForm.vue?vue&type=template&id=589a8892&"
import script from "./DossierForm.vue?vue&type=script&lang=ts&"
export * from "./DossierForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports